<p-toast></p-toast>

<app-page-shell>
  <app-page-hero eyebrow="Fleet" title="Fleet Documents" subtitle="Driver, vehicle, trailer, and rental compliance register.">
    <div actions>
      <p-button icon="pi pi-refresh" label="Evaluate" severity="secondary" [outlined]="true" (onClick)="evaluate()" [loading]="isLoading"></p-button>
      <p-button icon="pi pi-search" label="Search" (onClick)="load()" [loading]="isLoading"></p-button>
    </div>
  </app-page-hero>

  <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

  <section class="fleet-doc-grid">
    <app-page-data-panel title="Register" subtitle="Create or update expirable fleet documents.">
      <div class="fleet-doc-form">
        <label>
          <span>Resource</span>
          <p-select [options]="resourceTypeOptions.slice(1)" [(ngModel)]="form.resourceType" optionLabel="label" optionValue="value" appendTo="body"></p-select>
        </label>
        <label>
          <span>Resource ID</span>
          <input pInputText type="number" [(ngModel)]="form.resourceId" />
        </label>
        <label>
          <span>Document Type</span>
          <p-select [options]="documentTypeOptions.slice(1)" [(ngModel)]="form.documentType" optionLabel="label" optionValue="value" appendTo="body"></p-select>
        </label>
        <label>
          <span>Document Number</span>
          <input pInputText [(ngModel)]="form.documentNumber" />
        </label>
        <label>
          <span>Title</span>
          <input pInputText [(ngModel)]="form.title" />
        </label>
        <label>
          <span>Issue Date</span>
          <p-datepicker [(ngModel)]="form.issuedAt" appendTo="body" styleClass="w-full"></p-datepicker>
        </label>
        <label>
          <span>Expiry Date</span>
          <p-datepicker [(ngModel)]="form.expiryDate" appendTo="body" styleClass="w-full"></p-datepicker>
        </label>
        <label>
          <span>Warning Days</span>
          <input pInputText type="number" [(ngModel)]="form.alertLeadDays" />
        </label>
        <label>
          <span>Assigned Customer ID</span>
          <input pInputText type="number" [(ngModel)]="form.assignedCustomerId" />
        </label>
        <label class="wide">
          <span>File URL</span>
          <input pInputText [(ngModel)]="form.fileUrl" />
        </label>
        <label class="wide">
          <span>Notes</span>
          <input pInputText [(ngModel)]="form.notes" />
        </label>
        <label class="check-row">
          <input type="checkbox" [(ngModel)]="form.required" />
          <span>Required document</span>
        </label>
      </div>
      <div class="form-actions">
        <p-button icon="pi pi-save" [label]="form.documentId ? 'Update' : 'Create'" (onClick)="save()" [loading]="isSaving"></p-button>
        <p-button icon="pi pi-times" label="Clear" severity="secondary" [outlined]="true" (onClick)="resetForm()"></p-button>
      </div>
    </app-page-data-panel>

    <app-page-data-panel title="Filters" subtitle="Tenant is resolved from your session." [resultText]="documents.length + ' rows'">
      <div class="fleet-doc-filters">
        <p-select [options]="resourceTypeOptions" [(ngModel)]="filters.resourceType" optionLabel="label" optionValue="value" appendTo="body"></p-select>
        <p-select [options]="documentTypeOptions" [(ngModel)]="filters.documentType" optionLabel="label" optionValue="value" appendTo="body"></p-select>
        <p-select [options]="statusOptions" [(ngModel)]="filters.status" optionLabel="label" optionValue="value" appendTo="body"></p-select>
        <input pInputText type="number" placeholder="Resource ID" [(ngModel)]="filters.resourceId" />
      </div>
    </app-page-data-panel>
  </section>

  <app-page-data-panel title="Document Register">
    <p-table [value]="documents" [loading]="isLoading" [paginator]="true" [rows]="20" styleClass="p-datatable-sm">
      <ng-template pTemplate="header">
        <tr>
          <th>Resource</th>
          <th>Document</th>
          <th>Number</th>
          <th>Expiry</th>
          <th>Status</th>
          <th>Task</th>
          <th class="text-right">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-document>
        <tr>
          <td>
            <strong>{{ display(document.resourceType) }}</strong>
            <span class="muted">#{{ document.resourceId }}</span>
          </td>
          <td>{{ display(document.documentType) }}</td>
          <td>{{ document.documentNumber || '-' }}</td>
          <td>{{ document.expiryDate ? (document.expiryDate | date:'dd/MM/yyyy') : '-' }}</td>
          <td><p-tag [value]="display(document.status)" [severity]="severity(document.status)"></p-tag></td>
          <td>{{ document.productivityTaskId ? ('Task #' + document.productivityTaskId) : '-' }}</td>
          <td class="text-right">
            <p-button icon="pi pi-pencil" severity="secondary" [text]="true" [rounded]="true" (onClick)="edit(document)"></p-button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="empty-row">No fleet documents found.</td>
        </tr>
      </ng-template>
    </p-table>
  </app-page-data-panel>
</app-page-shell>
